export default "__VITE_ASSET__Bb26nR_S__"